import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-6"></div>
          <div className="col-sm-6">
            <div className="text-sm-end d-none d-sm-block">
              <script>document.write(new Date().getFullYear())</script> -SmartMedic.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
